import { CardButton, Description, IconSlot, TextGroup, Title } from './AccountCTACard.styles';
import type { AccountCTACardProps } from './AccountCTACard.types';

export function AccountCTACard({
  icon,
  title,
  description,
  onClick,
  ariaLabel,
}: AccountCTACardProps) {
  return (
    <CardButton type="button" onClick={onClick} aria-label={ariaLabel ?? title}>
      <IconSlot aria-hidden="true">{icon}</IconSlot>
      <TextGroup>
        <Title>{title}</Title>
        <Description>{description}</Description>
      </TextGroup>
    </CardButton>
  );
}
